<template>
  <section v-on:click="openMenu = false; shareOpen = false">
    <div class="tide"><div class="q1"></div><div class="q2"></div></div>
    <div class="tideBg"></div>
    <div class="logoCnt"><div class="logo"></div></div>
    <div class="sound">
      <div :class="{soundBtn: true, on: audioPlaying}"
        v-on:click="$emit('play')"></div>
      <div class="soundLabel">
        Sound
        <span v-if="audioPlaying">On</span>
        <span v-else>Off</span>
      </div>
    </div>
    <div class="menuToggle" v-on:click.stop="openMenu = !openMenu"></div>
    <div :class="{menu: true, open: openMenu}" v-on:click.stop="doNothing">
      <div class="menuItem left" v-on:click="openDownload">Download Brosur</div>
      <div class="menuItem right" v-on:click="openFaq">FAQ</div>
    </div>
    <div class="stages" :class="currView"
      v-on:touchstart="handleTouchStart"
      v-on:touchmove="handleTouchMove">
      <div class="stagePager">
        <div class="pageL" v-on:click="goRight" v-if="currView !== 'fun'"></div>
        <div class="pageR" v-on:click="goLeft" v-if="currView !== 'shopping'"></div>
      </div>
      <div class="stagePagination">
        <div :class="{pgItem: true, active: currView === 'fun'}"></div>
        <div :class="{pgItem: true, active: currView === 'main'}"></div>
        <div :class="{pgItem: true, active: currView === 'shopping'}"></div>
      </div>
      <div class="funAndLearn" :class="{closed: isCLosed}"
        v-on:click="openFunLearn">
        <div class="closedLabel">Tutup Sampai Pukul 17:00 WIB</div>
      </div>
      <div class="mainStage" v-on:click="$emit('pt'); $router.push('/main-stage')">
        <div class="countdown" v-if="!isLive">
          <div class="cdItem">
            {{cd.h}}<span>jam</span>
          </div>
          <div class="cdItem">
            {{cd.m}}<span>menit</span>
          </div>
          <div class="cdItem">
            {{cd.s}}<span>detik</span>
          </div>
        </div>
      </div>
      <div class="nutriliteShopping" :class="{closed: isCLosed}"
        v-on:click="openShopping">
        <div class="closedLabel">Tutup Sampai Pukul 17:00 WIB</div>
      </div>
    </div>
    <div class="payungA"></div><div class="payungB"></div>
    <div class="leafL"></div><div class="leafR"></div>
    <div class="rumputL"></div><div class="rumputL rumputL2"></div>
    <div class="rumputR"></div><div class="rumputR rumputR2"></div>
    <div class="bolaPantai"></div>
    <div class="crab1"></div><div class="crab2"></div>
    <div class="umang"></div><div class="umang2"></div>
    <div class="star1"></div><div class="star2"></div>
    <div class="copyright">
      <div class="shareFooter" :class="{open: shareOpen}"
        v-on:click.stop="shareOpen = !shareOpen"></div>
      <div class="socialLink" :class="{open: shareOpen}"
        v-on:click.stop="doNothing">
        <div class="sclLabel">Find Us On:</div>
        <a class="sclItem ig" target="_blank"
          href="https://www.instagram.com/nutrilite_id/"></a>
        <a class="sclItem fb" target="_blank"
          href="https://www.facebook.com/NutriliteID"></a>
        <a class="sclItem tw" target="_blank" :href="twUri"></a>
        <a class="sclItem wa" target="_blank" :href="waText"></a>
      </div>
      <div class="copy">
        &copy; Nutrilite Indonesia {{y}}
      </div>
    </div>
    <Add2Calendar ref="add2Calendar"/>
    <Download ref="download"/>
    <Main ref="main"/>
    <Faq ref="faq"/>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import Add2Calendar from '@/components/Add2Calendar.vue';
import Main from '@/components/Main.vue';
import Faq from '@/components/Faq.vue';
import Download from '@/components/Download.vue';

export default {
  name: 'home',
  components: {
    Add2Calendar,
    Main,
    Faq,
    Download,
  },
  data() {
    return {
      y: '',
      name: '',
      player: null,
      currView: 'main',
      xDown: null,
      yDown: null,
      openMenu: false,
      cd: { h: '--', m: '--', s: '--' },
      isLive: true,
      shareOpen: false,
      liveDate: new Date('2021-10-02T08:00:00.000Z'),
      closedDate: {
        from: new Date('2021-10-02T08:00:00.000Z'),
        to: new Date('2021-10-02T10:00:00.000Z'),
      },
    };
  },
  methods: {
    doNothing() {},
    openDownload() {
      this.openMenu = false;
      this.$refs.download.open();
    },
    openFaq() {
      this.openMenu = false;
      this.$refs.faq.open();
    },
    openFunLearn() {
      if (this.isCLosed) return;
      this.$emit('pt');
      this.$router.push('/fun-and-learn');
    },
    openShopping() {
      if (this.isCLosed) return;
      this.$emit('pt');
      this.$router.push('/nutrilite-shopping');
    },
    getTouches(evt) {
      return evt.touches || evt.originalEvent.touches;
    },
    handleTouchStart(evt) {
      const firstTouch = this.getTouches(evt)[0];
      this.xDown = firstTouch.clientX;
      this.yDown = firstTouch.clientY;
    },
    handleTouchMove(evt) {
      if (!this.xDown || !this.yDown) {
        return;
      }
      const xUp = evt.touches[0].clientX;
      const yUp = evt.touches[0].clientY;
      const xDiff = this.xDown - xUp;
      const yDiff = this.yDown - yUp;
      if (Math.abs(xDiff) > Math.abs(yDiff)) {
        if (xDiff > 0) this.goLeft();
        else this.goRight();
      }
      this.xDown = null;
      this.yDown = null;
    },
    goLeft() {
      if (this.currView === 'main') this.currView = 'shopping';
      else if (this.currView === 'fun') this.currView = 'main';
    },
    goRight() {
      if (this.currView === 'main') this.currView = 'fun';
      else if (this.currView === 'shopping') this.currView = 'main';
    },
    add2Calendar() {
      this.$refs.add2Calendar.open();
    },
    startCoundown() {
      clearInterval(this.cdInterval);
      const now2 = Date.now();
      const dst = this.liveDate.getTime() - now2;
      const h2 = Math.floor((dst % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const m2 = Math.floor((dst % (1000 * 60 * 60)) / (1000 * 60));
      const s2 = Math.floor((dst % (1000 * 60)) / 1000);
      this.cd.h = (h2 < 10) ? `0${h2.toString()}` : h2.toString();
      this.cd.m = (m2 < 10) ? `0${m2.toString()}` : m2.toString();
      this.cd.s = (s2 < 10) ? `0${s2.toString()}` : s2.toString();
      if (dst < 0) this.isLive = true;
      this.cdInterval = setInterval(() => {
        const now = Date.now();
        const distance = this.liveDate.getTime() - now;
        const h = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const m = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const s = Math.floor((distance % (1000 * 60)) / 1000);
        this.cd.h = (h < 10) ? `0${h.toString()}` : h.toString();
        this.cd.m = (m < 10) ? `0${m.toString()}` : m.toString();
        this.cd.s = (s < 10) ? `0${s.toString()}` : s.toString();
        if (distance < 0) {
          clearInterval(this.cdInterval);
          this.isLive = true;
        }
      }, 1000);
    },
  },
  computed: {
    ...mapState(['audioPlaying']),
    shareText() {
      return 'Yuk ikutan #YouthfuelSummerFest bersama @nutrilite_id';
    },
    twUri() {
      return 'https://twitter.com/intent/tweet?url='
        + `${escape('https://nutrilite.co.id/youthfuelsummerfest/')}`
        + `&text=${escape(this.shareText)}&related=Amway,Nutrilite,Collagen`;
    },
    waText() {
      return 'https://api.whatsapp.com/send/?phone&text='
        + `${escape(`${this.shareText} di https://nutrilite.co.id/youthfuelsummerfest/`)}`
        + '&app_absent=0';
    },
    isCLosed() {
      const d = new Date();
      return (d.getTime() >= this.closedDate.from.getTime()
        && d.getTime() <= this.closedDate.to.getTime());
    },
  },
  mounted() {
    const d = new Date();
    this.y = d.getFullYear();
    this.name = localStorage.getItem('name');
    const token = localStorage.getItem('token');
    if (!token) {
      this.$refs.main.open((name) => {
        this.name = name;
      });
    }
    this.isLive = d.getTime() >= this.liveDate.getTime();
    if (!this.isLive) this.startCoundown();
  },
};
</script>

<style scoped lang="scss">
section{
  background-color: #f6c8c8;
  background-image: url(../assets/main-bg.jpg);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: fixed;
  left: 0; top: 0; right: 0; bottom: 0;
  @media (max-height: 640px) {
    position: static;
  }
  @media (max-height: 640px) and (max-width: 680px) {
    position: fixed;
  }
}

.logo{
  width: 300px; height: 300px;
  margin: 0 auto;
  position: relative;
  z-index: 9;
  background-image: url(../assets/logo.png);
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  @media (max-width: 1300px) {
    width: 260px; height: 260px;
  }
  @media (max-width: 680px) {
    width: 180px; height: 180px;
  }
}
.bolaPantai{
  width: 120px; height: 120px;
  position: fixed;
  right: -30px; top: 50%;
  transform: translateY(-50%);
  margin-top: -30px;
  background-image: url(../assets/bola-pantai.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 4;
  @media (max-width: 1100px) and (max-height: 1100px) {
    width: 80px; height: 80px;
  }
  @media (max-height: 760px) {
    right: -80px;
  }
  @media (max-width: 680px) {
    top: auto; bottom: 160px;
  }
}
.crab1{
  width: 80px; height: 80px;
  position: fixed;
  left: -40px; bottom: 120px;
  background-image: url(../assets/kepiting-orange.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  // left: 400px;
  animation: crab1An 20s infinite ease;
  z-index: 3;
  @media (max-width: 680px) {
    width: 54px; height: 54px; bottom: 120px;
    animation: crab1AnSm 20s infinite ease;
  }
  @keyframes crab1An {
    0% {left: -40px;}
    45% {left: 460px;}
    55% {left: 460px;}
    100% {left: -40px;}
  }
  @keyframes crab1AnSm {
    0% {left: -40px;}
    45% {left: 200px;}
    55% {left: 200px;}
    100% {left: -40px;}
  }
}
.crab2{
  width: 80px; height: 80px;
  position: fixed;
  right: -40px; bottom: 200px;
  background-image: url(../assets/kepiting-pink.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  animation: crab2An 20s infinite ease;
  z-index: 3;
  @media (max-width: 680px) {
    width: 54px; height: 54px; bottom: 160px;
    animation: crab2AnSm 20s infinite ease;
  }
  @keyframes crab2An {
    0% {right: -40px;}
    45% {right: 420px;}
    55% {right: 420px;}
    100% {right: -40px;}
  }
  @keyframes crab2AnSm {
    0% {right: -40px;}
    45% {right: 180px;}
    55% {right: 180px;}
    100% {right: -40px;}
  }
}
.star1{
  width: 74px; height: 74px;
  position: fixed;
  left: 260px; top: 180px;
  background-image: url(../assets/star-orange.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 1;
  @media (max-width: 680px) {
    width: 40px; height: 40px;
    left: 40px; top: 120px;
  }
}
.star2{
  width: 74px; height: 74px;
  position: fixed;
  right: 36%; top: 260px;
  background-image: url(../assets/star-pink.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 1;
  @media (max-width: 680px) {
    width: 64px; height: 64px;
    right: 60px; top: 200px;
  }
}
.umang{
  width: 74px; height: 74px;
  position: fixed;
  left: -74px; top: 220px;
  background-image: url(../assets/umang-grey.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  animation: umangAn 65s infinite linear;
  z-index: 2;
  @media (max-width: 680px) {
    width: 40px; height: 40px; top: 140px;
  }
  @keyframes umangAn {
    from { left: -74px; }
    to { left: 110%; }
  }
}
.umang2{
  width: 74px; height: 74px;
  position: fixed;
  right: -74px; top: 200px;
  background-image: url(../assets/umang-pink.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  animation: umang2An 65s infinite linear;
  z-index: 2;
  @media (max-width: 680px) {
    width: 40px; height: 40px; top: 120px;
  }
  @keyframes umang2An {
    from { right: -74px; }
    to { right: 110%; }
  }
}
.payungA{
  width: 260px; height: 260px;
  position: fixed;
  left: -120px; bottom: 160px;
  background-image: url(../assets/umbrela-red.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 7;
  @media (max-width: 1100px) and (max-height: 1100px) {
    width: 200px; height: 200px;
    left: -100px; bottom: 100px;
  }
  @media (max-height: 760px) {
    width: 200px; height: 200px;
    left: -100px; bottom: 100px;
  }
  @media (max-width: 680px) {
    width: 120px; height: 120px;
    left: -60px; bottom: 60px;
  }
}
.payungB{
  width: 280px; height: 280px;
  position: fixed;
  left: 50%; bottom: -160px;
  background-image: url(../assets/umbrela-pink.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 7;
  @media (max-width: 1100px) and (max-height: 1100px) {
    width: 180px; height: 180px;
    bottom: -100px;
  }
  @media (max-height: 760px) {
    bottom: -200px;
  }
}
.leafL{
  width: 540px; height: 540px;
  position: fixed;
  left: -200px; bottom: -176px;
  background-image: url(../assets/leaf-l.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  animation: l1An 10s infinite ease;
  z-index: 8;
  @media (max-width: 1100px) and (max-height: 1100px) {
    width: 400px; height: 400px;
    left: -140px; bottom: -140px;
  }
  @media (max-height: 760px) {
    width: 400px; height: 400px;
    left: -140px; bottom: -140px;
  }
  @media (max-width: 680px) {
    width: 240px; height: 240px;
    left: -80px; bottom: -80px;
  }
  @keyframes l1An {
    0% {transform: rotate(0deg);}
    10% {transform: rotate(0deg);}
    45% {transform: rotate(10deg);}
    55% {transform: rotate(10deg);}
    90% {transform: rotate(0deg);}
    100% {transform: rotate(0deg);}
  }
}
.leafR{
  width: 540px; height: 540px;
  position: fixed;
  right: -180px; bottom: -140px;
  background-image: url(../assets/leaf-r.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  animation: windAn 10s infinite ease;
  z-index: 8;
  @media (max-width: 1100px) and (max-height: 1100px) {
    width: 400px; height: 400px;
    right: -140px; bottom: -140px;
  }
  @media (max-height: 760px) {
    width: 400px; height: 400px;
    right: -140px; bottom: -140px;
  }
  @media (max-width: 680px) {
    width: 240px; height: 240px;
    right: -80px; bottom: -80px;
  }
}
.rumputL{
  width: 280px; height: 500px;
  position: fixed;
  left: 380px; bottom: -396px;
  background-image: url(../assets/rumput-l.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  animation: windAn 10s infinite ease;
  z-index: 8;
  @media (max-width: 1100px) and (max-height: 1100px) {
    height: 400px; bottom: -320px; left: 240px;
  }
  @media (max-height: 760px) {
    height: 400px; bottom: -320px; left: 240px;
  }
  @media (max-width: 680px) {
    height: 240px;
    bottom: -180px; left: 60px;
  }
  &.rumputL2{
    background-image: url(../assets/rumput-r.png);
    left: 600px;
    bottom: -420px;
  }
}
.rumputR{
  width: 280px; height: 500px;
  position: fixed;
  right: 260px; bottom: -396px;
  background-image: url(../assets/rumput-r.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  animation: windAn 10s infinite ease;
  z-index: 8;
  @media (max-width: 1100px) and (max-height: 1100px) {
    right: 200px; height: 400px; bottom: -320px;
  }
  @media (max-height: 760px) {
    right: 200px; height: 400px; bottom: -320px;
  }
  @media (max-width: 680px) {
    display: none;
  }
  &.rumputR2{
    background-image: url(../assets/rumput-l.png);
    right: 460px;
    bottom: -420px;
    @media (max-width: 1600px) {
      display: none;
    }
  }
}
@keyframes windAn {
  0% {transform: rotate(0deg);}
  10% {transform: rotate(0deg);}
  45% {transform: rotate(8deg);}
  55% {transform: rotate(8deg);}
  90% {transform: rotate(0deg);}
  100% {transform: rotate(0deg);}
}
.tideBg{
  background-image: url(../assets/tide-bg.png);
  background-size: cover;
  background-position: bottom center;
  background-repeat: no-repeat;
  position: absolute;
  left: 0; right: 0; top: 60px;
  height: 360px;
  z-index: 1;
  @media (max-width: 1100px) and (max-height: 1100px) {
    height: 280px;
  }
  @media (max-height: 760px) {
    height: 280px;
  }
  @media (max-width: 680px) {
    height: 160px;
  }
}
.tide{
  background-image: url(../assets/tide.png);
  background-size: cover;
  background-position: bottom center;
  background-repeat: no-repeat;
  position: absolute;
  left: 0; right: 0; top: -100px;
  height: 360px;
  animation: tideAn 10s infinite ease;
  z-index: 3;
  @media (max-width: 1100px) and (max-height: 1100px) {
    height: 280px;
  }
  @media (max-height: 760px) {
    height: 280px;
  }
  @media (max-width: 680px) {
    height: 240px;
    animation: tideAnSm 10s infinite ease;
  }
  @keyframes tideAn {
    0% {top: -100px;}
    40% {top: 0;}
    60% {top: 0;}
    100% {top: -100px;}
  }
  @keyframes tideAnSm {
    0% {top: -114px;}
    40% {top: -40px;}
    60% {top: -40px;}
    100% {top: -114px;}
  }
  .q1{
    width: 100px; height: 100px;
    background-image: url(../assets/q1.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    position: absolute;
    left: 300px; top: 100px;
    animation: q1An 10s infinite ease;
    @media (max-width: 1100px) and (max-height: 1100px) {
      top: 70px;
    }
    @media (max-width: 680px) {
      width: 60px; height: 60px; top: 120px;
      animation: q1AnSm 10s infinite ease;
    }
    @keyframes q1An {
      0% {left: 200px;}
      10% {left: 200px;}
      45% {left: 300px;}
      55% {left: 300px;}
      90% {left: 200px;}
      100% {left: 200px;}
    }
    @keyframes q1AnSm {
      0% {left: -20px;}
      10% {left: -20px;}
      45% {left: 60px;}
      55% {left: 60px;}
      90% {left: -20px;}
      100% {left: -20px;}
    }
  }
  .q2{
    width: 100px; height: 100px;
    background-image: url(../assets/q2.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    position: absolute;
    right: 300px; top: 100px;
    animation: q2An 10s infinite ease;
    @media (max-width: 680px) {
      width: 60px; height: 60px; top: 120px;
      animation: q2AnSm 10s infinite ease;
    }
    @keyframes q2An {
      0% {right: 200px;}
      10% {right: 200px;}
      45% {right: 300px;}
      55% {right: 300px;}
      90% {right: 200px;}
      100% {right: 200px;}
    }
    @keyframes q2AnSm {
      0% {right: -20px;}
      10% {right: -20px;}
      45% {right: 60px;}
      55% {right: 60px;}
      90% {right: -20px;}
      100% {right: -20px;}
    }
  }
}
.stages{
  display: flex;
  justify-content: space-evenly;
  position: absolute;
  top: 50%; left: 40px; right: 40px;
  transform: translateY(-50%);
  z-index: 99;
  transition: all .3s ease;
  .stagePagination{ display: none;  }
  .stagePager{ display: none;  }
  @media (max-height: 640px) {
    position: relative;
    left: auto; right: auto; top: auto; bottom: auto;
    transform: none;
    margin: -100px 0 0;
    padding-bottom: 100px;
  }
  @media (max-width: 680px) {
    .stagePagination{
      position: absolute;
      bottom: -40px;
      display: block;
      z-index: 999;
      display: flex;
      justify-content: center;
      .pgItem{
        width: 8px; height: 8px;
        background-color: #b77795;
        border-radius: 50%;
        margin: 0 5px;
        &.active{
          background-color: #ff6759;
        }
      }
    }
    .stagePager{
      display: block;
      .pageL{
        position: absolute;
        left: 50%; width: 260px;
        margin-left: -400px;
        top: 0; bottom: 0;
        z-index: 3;
        background-image: url(../assets/share/prev.svg);
        background-size: 30px auto;
        background-repeat: no-repeat;
        background-position: right center;
      }
      .pageR{
        position: absolute;
        right: 50%; width: 260px;
        margin-right: -400px;
        top: 0; bottom: 0;
        z-index: 3;
        background-image: url(../assets/share/next.svg);
        background-size: 30px auto;
        background-position: left center;
        background-repeat: no-repeat;
      }
    }
  }
  .funAndLearn, .mainStage, .nutriliteShopping{
    width: 360px; height: 360px;
    // animation: stageAnimation2 4s infinite linear;
    // margin: 0 40px;
    cursor: pointer;
    position: relative;
    transition: all .3s ease;
    .closedLabel{
      display: none;
    }
    &.closed{
      filter: grayscale(1);
      opacity: .8;
      cursor: default;
      .closedLabel{
        display: block;
        position: absolute;
        z-index: 99;
        font-weight: bold;
        font-size: 20px;
        text-align: center;
        left: 0; right: 0;
        bottom: 0px;
        text-shadow: 2px 2px 6px rgba(0,0,0,.4);
      }
    }
    &:hover{
      transform: scale(1.1);
    }
    &:before{
      content: "";
      position: absolute;
      width: 200px; height: 100px;
      background-color: rgba(0,0,0,.3);
      border-radius: 50px;
      filter: blur(14px);
      bottom: 6px; left: 50%;
      transform: translateX(-100px);
      z-index: 1;
      @media (max-width: 960px) {
        width: 160px; height: 70px; bottom: 56px;
        transform: translateX(-80px);
      }
    }
    &:after{
      content: "";
      position: absolute;
      left: 0; right: 0; top: 0; bottom: 0;
      z-index: 2;
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
    }
    @media (max-height: 760px) {
      height: 300px;
    }
    @media (max-width: 680px) {
      // background-color: rgba(0,0,0,.12);
      border-radius: 10px;
      position: absolute;
      top: 0; bottom: 0; height: auto;
      left: 50%; width: 260px;
      transform: none;
      margin-left: -130px;
      &:hover{
        transform: none;
      }
    }
  }
  .nutriliteShopping{
    // filter: grayscale(1);
    @media (max-width: 680px) {
      // background-color: #ffb178;
    }
    &:before{
      transform: translateX(-60px);
    }
    &:after{
      background-image: url(../assets/nutrilite-shopping.png);
    }
  }
  .funAndLearn{
    // filter: grayscale(1);
    @media (max-width: 680px) {
      // background-color: #ffa6b5;
    }
    &:after{
      background-image: url(../assets/fun-and-learn.png);
    }
  }
  .mainStage{
    margin-top: 160px;
    @media (max-width: 680px) {
      margin-top: 0;
      // background-color: #ffbf80;
      // background-color: #f8e051;
    }
    .countdown{
      width: 280px; height: 114px;
      position: absolute;
      z-index: 3;
      bottom: -68px; left: 50%;
      margin-left: -140px;
      background-image: url(../assets/countdown.png);
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      display: flex;
      justify-content: center;
      box-sizing: border-box;
      padding-top: 26px;
      .cdItem{
        font-size: 30px;
        text-align: center;
        width: 60px;
        span{
          display: block;
          font-size: 15px;
          font-weight: normal;
          margin-top: -10px;
        }
      }
      @media (max-width: 960px) {
        bottom: -10px; margin-left: -100px;
        width: 200px; height: 86px;
        padding-top: 19px;
        .cdItem{
          font-size: 24px;
          width: 44px;
          span{
            display: block;
            font-size: 12px;
            font-weight: normal;
            margin-top: -6px;
          }
        }
      }
      @media (max-width: 680px) {
        bottom: -40px;
      }
    }
    &:after{
      background-image: url(../assets/main-stage.png);
    }
  }
  @media (max-width: 680px) {
    left: 0; right: 0; height: 300px;
    &.main{
      .funAndLearn{
        transform: scale(.70) translateX(-330px);
      }
      .nutriliteShopping{
        transform: scale(.70) translateX(330px);
      }
    }
    &.fun{
      .mainStage{
        transform: scale(.70) translateX(330px);
      }
      .nutriliteShopping{
        transform: scale(.70) translateX(660px);
      }
    }
    &.shopping{
      .mainStage{
        transform: scale(.70) translateX(-330px);
      }
      .funAndLearn{
        transform: scale(.70) translateX(-660px);
      }
    }
  }
}
</style>
